<div class="row cfa-nowrap-row cfa-button">
    <div class="col-auto pr-0 pl-0">
        <svg-icon src="{{getIconUrl()}}" class="cfa-icon"></svg-icon>
    </div>
</div>
